import React from 'react';
import questions from '../Questionnaire/data/questions';
import styles from './css/Question.styl';
import classNames from 'classnames';
import backArrow from '../../assets/backArrow.png';
import closeX from '../../assets/closeX.png';
import {QUESTION_PARAM} from '../../../../shared/utilities/constants';
import {setVirtualPageView} from '../../../../shared/utilities/GAHelpers';
import _partial from 'lodash/partial';
import _isNil from 'lodash/isNil';

class Question extends React.Component {
  static propTypes = {
    answerIndex: React.PropTypes.number,
    answers: React.PropTypes.array,
    handleAnswer: React.PropTypes.func.isRequired,
    handleBack: React.PropTypes.func.isRequired,
    handleClose: React.PropTypes.func.isRequired,
    handleSkip: React.PropTypes.func.isRequired,
    help: React.PropTypes.string,
    question: React.PropTypes.string.isRequired,
    step: React.PropTypes.number.isRequired,
    total: React.PropTypes.number.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {selectedOption: null, hoveredOption: null};

    this.handleAnswer = this.handleAnswer.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleHover = this.handleHover.bind(this);
    this.handleUnhover = this.handleUnhover.bind(this);
  }

  componentDidMount() {
    setVirtualPageView(
      `/funeral-homes/planning?${QUESTION_PARAM}=${questions[0].page}`
    );
  }

  componentWillReceiveProps(nextProps) {
    const {step: currentStep} = this.props;
    const {step: nextStep} = nextProps;

    if (currentStep !== nextStep) {
      this.setState({selectedOption: nextProps.answerIndex});
      this.handleUnhover();
      setVirtualPageView(
        `/funeral-homes/planning?${QUESTION_PARAM}=${
          questions[nextStep - 1].page
        }`
      );
    }
  }

  handleAnswer(changeEvent) {
    this.setState({selectedOption: changeEvent.target.value});
    this.props.handleAnswer(changeEvent.target.value);
  }

  handleClose() {
    setVirtualPageView('/funeral-homes/planning');
    this.props.handleClose();
  }

  handleHover(hoveredIndex) {
    this.setState({hoveredOption: hoveredIndex});
  }

  handleUnhover() {
    this.setState({hoveredOption: null});
  }

  render() {
    const question = this.props.question;
    const answers = this.props.answers.map((answer, idx) => {
      const answerClass = classNames(
        styles.Answer,
        this.state.selectedOption === `${idx}` ? styles.Selected : null,
        this.state.hoveredOption === idx ? styles.Hover : null
      );

      return (
        <div
          className={answerClass}
          key={`answer-${idx}`}
          onMouseEnter={_partial(this.handleHover, idx)}
          onMouseLeave={this.handleUnhover}
        >
          <label className={styles.AnswerText}>
            <input
              className={styles.AnswerSelect}
              checked={this.state.selectedOption === `${idx}`}
              onChange={this.handleAnswer}
              type="radio"
              value={`${idx}`}
            />
            {answer}
          </label>
        </div>
      );
    });

    return (
      <div className={styles.Question}>
        <div className={styles.Nav}>
          <div
            className={classNames(
              styles.Back,
              this.props.step === 1 ? styles.Hidden : null
            )}
            onClick={this.props.handleBack}
          >
            <img src={backArrow} /> <span>Back</span>
          </div>
          <div className={styles.Close} onClick={this.handleClose}>
            <img src={closeX} />
          </div>
        </div>

        <p className={styles.QuestionText}>{question}</p>

        <div className={styles.Answers}>{answers}</div>

        {_isNil(this.props.help) ? null : (
          <div className={styles.QuestionHelp}>{this.props.help}</div>
        )}

        <div className={styles.Indicator}>
          <div
            className={styles.Progress}
            style={{width: `${(100 * this.props.step) / this.props.total}%`}}
          />
        </div>

        <div className={styles.Skip} onClick={this.props.handleSkip}>
          Skip
        </div>
      </div>
    );
  }
}

export default Question;



// WEBPACK FOOTER //
// ./src/reactModules/pages/Planning/components/Question/index.js